require([
	'jquery',
	'root/Base/Js/MbiImageSize',
	'root/Base/Js/MbiMediaQuery',
	'flickity'
], function(
	$,
	mbiImageSize,
	mbiMq,
	flickity
	) {

	'use strict';

	if($('.imageSlider').length>0){

		var imageSlider = new flickity( '.imageSlider', {
			cellSelector: '.slide',
			pageDots: false,
			wrapAround: true,
			prevNextButtons: true,
			watchCSS: false,
			dragThreshold: 20,
			arrowShape: {
			  x0: 0,
			  x1: 50, y1: 50,
			  x2: 5, y2: 0,
			  x3: 100
			}
		});
	}

});
define("root/Assets/Templates/Html/ImageSlider/Js/ImageSlider", function(){});

